import { Injectable } from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {AuthService} from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class RepairsGuardService implements CanActivate {
  constructor(private authService: AuthService,
              private router: Router) {
  }

  canActivate() {
    return this.authService.getUser().then((user) => {
      if (user.role_alternate_name === 'basicUser' ||
        user.role_alternate_name === 'callCenterManager' ||
        user.role_alternate_name === 'customerManager' ||
        user.role_alternate_name === 'technicalManager' ||
        user.role_alternate_name === 'salesDirector' ||
        user.role_alternate_name === 'hqManager' ||
        user.role_alternate_name === 'technicalManagerNew') {
        return true;
      }

      this.router.navigate(['access-denied']);

      return false;
    });
  }
}
